import { MUTATION_GROUP } from './constants.tsx';
import type { JiraSingleLineTextFieldInput } from './types.tsx';

export const mutateTextField = (value: string, fieldId: string): JiraSingleLineTextFieldInput => ({
	fieldId,
	text: value,
	mutationGroup: MUTATION_GROUP,
});
